/**
 * Task #4040 — URL di download per gli oggetti storage (allegati chat/feed,
 * thumbnail File Manager) serviti da `GET /api/storage/<chiave>`.
 *
 * Il backend fa ownership check tenant-scoped e risponde con redirect a
 * presigned URL R2 breve (o stream locale in dev).
 *
 * Il token JWT è passato in query string perché `<img src>` / `<a href>`
 * non inviano l'Authorization header; il middleware backend accetta
 * `?token=` solo su questo endpoint asset GET (allowlist esplicita), come
 * già avviene per avatar/cover dei workgroup (vedi workgroup-avatar.ts).
 */

import { AUTH_STORAGE_KEYS } from '@/constants/auth';

const TOKEN_STORAGE_KEY = AUTH_STORAGE_KEYS.TOKEN;

/**
 * Costruisce l'URL servibile per una chiave storage. Passa attraverso gli
 * URL già assoluti (http/https, data:, blob:) senza toccarli.
 */
export function storageFileUrl(raw: string | null | undefined): string {
  if (!raw) return '';
  if (raw.startsWith('http') || raw.startsWith('data:') || raw.startsWith('blob:')) return raw;
  const key = raw.replace(/^\/+/, '').split('/').map(encodeURIComponent).join('/');
  const tok = typeof localStorage !== 'undefined' ? localStorage.getItem(TOKEN_STORAGE_KEY) : null;
  const t = tok ? `?token=${encodeURIComponent(tok)}` : '';
  return `/api/storage/${key}${t}`;
}
